import React from "react";
import "../../assets/css/AlertBanner.css";
import ReactHtmlParser from 'react-html-parser';
import { isNullOrUndefined } from '../modules/CommonFunctions';
import {Notification} from '@vds/notifications';
import { node } from "webpack";

const AlertBanner = (props) => {

  let notifications = props && props.AlertBannerData && props.AlertBannerData.sitealerts ?  props.AlertBannerData.sitealerts : [];
  let isBreadCrumb = props.isBreadCrumb || [];
  let showBanner = props.showBanner || true;

  notifications.forEach(item => {

    const tempEle = new DOMParser().parseFromString(item.notification, 'text/html');
    const boldEle = tempEle.querySelector('b');
    if (boldEle) {
      item.title = boldEle.textContent.trim();
      const siblingNode = Array.from(boldEle.parentNode.childNodes);
      const desNodes = siblingNode.slice(siblingNode.indexOf(boldEle) + 1).filter(node => node.nodeType === Node.TEXT_NODE);
      item.description = desNodes.map(node => node.textContent.trim()).join('');
    }
    
  });
 
  notifications.forEach( item =>{
    const buttonData = [];

    if (item.ctaLabel1) {
      if (item.ctaLink1 !== "#") {
        buttonData.push({
          children:item.ctaLabel1,
          onclick: e =>{
            window.location.href = item.ctaLink1
          }
  
        })
      }else{
        buttonData.push({
          children:item.ctaLabel1,
          onclick: e =>{
            window.location.href = item.ctaLink1
          }
  
        })
      }
        }

        if (item.ctaLabel2) {
          if (item.ctaLink2 !== "#") {
            buttonData.push({
              children:item.ctaLabel2,
              onclick: e =>{
                window.location.href = item.ctaLink2
              }
      
            })
          }else{
            buttonData.push({
              children:item.ctaLabel2,
              onclick: e =>{
                window.location.href = item.ctaLink2
              }
      
            })
          }
            }

    item.buttonData = buttonData;
  });


  return (
    <div>
    {showBanner ? (
    <div className={`${isBreadCrumb ? 'alert-container'  : "" }`}>
       {notifications.map((item,index)=> (
      <Notification
        type={item.category}
        title={item.title}
        subtitle={item.description}
        surface="light"
        disableAnimation={false}
        fullBleed={false}
        hideCloseButton={false}
        disableFocus={true}
        inline={false}
        layout={null}
        buttonData={item.buttonData}  
        className="alert-content-div"
        />
       ))}
    </div>
   
  )
  : null}
  </div>
  )
}

export default AlertBanner;


// WEBPACK FOOTER //
// ./src/components/modules/AlertBanner.js